import React from "react";
import { useNavigateStore } from "../../stepFlowHooks/useNavigateStore";
import { StepId } from "../../enums/navigation";
import SignInStep from "../../components/authentication/signIn/SignInStep";
import { StreamingStep } from "../steps/StreamingStep/StreamingStep";
import { PostSignInStep } from "../steps/PostSignInStep/PostSignInStep";
import { InitStep } from "../steps/InitStep/InitStep";
import { PostStreamingStep } from "../steps/PostStreamingStep/PostStreamingStep";
import { PreStreamingStep } from "../steps/PreStreamingStep/PreStreamingStep";

export const Navigator = () => {
    const stepId = useNavigateStore((store) => store.stepId);

    switch (stepId) {
        case StepId.INIT:
            return <InitStep />;
        case StepId.SIGN_IN:
            return <SignInStep />;
        case StepId.POST_SIGN_IN:
            return <PostSignInStep />;
        case StepId.PRE_STREAMING:
            return <PreStreamingStep />;
        case StepId.STREAMING:
            return <StreamingStep />;
        case StepId.POST_STREAMING:
            return <PostStreamingStep />;
        default:
            // Should not reach here, but just in case.
            // TODO [LOWA-30534] Add a error metric to monitor exceptional case
            //      Also show an error page
            return <></>;
    }
};
